import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getConfigDefaultSaga(
  action: types.GetConfigDefaultActionType
) {
  try {
    const response = yield call(
      services.getConfigDefaultService,
      action.payload
    );
    if (response.data) {
      yield put({ type: actions.GET_CONFIG_DEFAULT_SUCCESS, response });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({
      type: actions.GET_CONFIG_DEFAULT_ERROR,
      error,
    });
    toastr.error("Default Config Not Loaded", `${error.error.message}`);
  }
}

export function* getConfigSaga(action: types.GetConfigActionType) {
  try {
    const response = yield call(services.getConfigService, action.payload);
    yield put({
      type: actions.GET_CONFIG_SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: actions.GET_CONFIG_ERROR,
      error,
    });
    toastr.error("Config Not Loaded", `${error.error.message}`);
  }
}

export function* getConfigsSaga(action: types.GetConfigsActionType) {
  try {
    const response = yield call(services.getConfigsService, action.payload);
    yield put({
      type: actions.GET_CONFIGS_SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: actions.GET_CONFIGS_ERROR,
      error,
    });
    toastr.error("Configs Not Loaded", `${error.error.message}`);
  }
}

export function* addConfigKeySaga(action: types.AddConfigKeyActionType) {
  try {
    const addResponse = yield call(
      services.addConfigKeyService,
      action.payload
    );
    const getResponse = yield call(services.getConfigsService);
    if (addResponse.data) {
      yield put({
        type: actions.ADD_CONFIG_KEY_SUCCESS,
        response: addResponse,
      });
      yield put({
        type: actions.GET_CONFIGS_SUCCESS,
        response: getResponse,
      });
      toastr.success(
        "Config Key Created",
        `Added '${action.payload.body.key}'`
      );
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({
      type: actions.ADD_CONFIG_KEY_ERROR,
      error,
    });
    toastr.error("Config Key Not Created", `${error.error.message}`);
  }
}

export function* modifyConfigKeySaga(action: types.ModifyConfigKeyActionType) {
  try {
    const modifyResponse = yield call(
      services.modifyConfigKeyService,
      action.payload
    );
    const getResponse = yield call(services.getConfigsService);
    if (modifyResponse.data) {
      yield put({
        type: actions.MODIFY_CONFIG_KEY_SUCCESS,
        response: modifyResponse,
      });
      yield put({
        type: actions.GET_CONFIGS_SUCCESS,
        response: getResponse,
      });
      toastr.success("Config Key Modified", `Success`);
    } else {
      throw modifyResponse;
    }
  } catch (error) {
    yield put({
      type: actions.MODIFY_CONFIG_KEY_ERROR,
      error,
    });
    toastr.error("Config Key Not Modified", `${error.error.message}`);
  }
}

export function* deleteConfigKeySaga(action: types.DeleteConfigKeyActionType) {
  try {
    const deleteResponse = yield call(
      services.deleteConfigKeyService,
      action.payload
    );
    const getResponse = yield call(services.getConfigsService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_CONFIG_KEY_SUCCESS,
        response: deleteResponse,
      });
      yield put({
        type: actions.GET_CONFIGS_SUCCESS,
        response: getResponse,
      });
      toastr.success("Config Key Deleted", `Success`);
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({
      type: actions.DELETE_CONFIG_KEY_ERROR,
      error,
    });
    toastr.error("Config Key Not Deleted", `${error.error.message}`);
  }
}
